import React from "react";
import { ColumnSortingState } from "../../FolderExplorer/FolderListView/FolderListView";
import SelectAllCheckBox from "../../UI/CheckBox/SelectAllCheckBox/SelectAllCheckBox";

import ArrowUp from "../../../assets/icons/arrow_up.svg";
import ArrowDown from "../../../assets/icons/arrow_down.svg";

const listViewHeader = (props) => {
  const { isSortableCol = false } = props ?? {};
  const handleColumnClick = () => {
    if (props.sortingValue) {
      let status = ColumnSortingState.ASC;
      if (
        props.sortingValue &&
        props.sortingValue.column === props.columnName
      ) {
        if (props.sortingValue.status === ColumnSortingState.ASC) {
          status = ColumnSortingState.DESC;
        } else {
          status = ColumnSortingState.ASC;
        }
      }
      props.sortColumnHandler({ column: props.columnName, status: status });
    }
  };
  return (
    <th
      scope="col"
      className={
        props.columnName === "Files" ? "d-flex files-bottom-boarder" : ""
      }
      style={{ cursor: isSortableCol ? "pointer" : "context-menu" }}
      onClick={handleColumnClick}
    >
      <div className="d-flex">
        {props.columnName === "Files" ? (
          props.isCheckbox ? (
            <>
              <SelectAllCheckBox
                checked={props.checked}
                selectAllHandler={props.selectAllHandler}
              />
              <div className="pl-3">
                {props.isFolder ? "Sub-folders" : props.columnName}{" "}
                {props.count ? <span>({props.count})</span> : null}
              </div>
            </>
          ) : (
            <>
              {props.isFolder ? "Sub-folders" : props.columnName}{" "}
              {props.count ? <span>({props.count})</span> : null}
            </>
          )
        ) : (
          <>{props.columnName}</>
        )}
        <div className="arrow">
          {props.sortingValue &&
          props.sortingValue.column === props.columnName ? (
            <img
              src={
                props.sortingValue.status === ColumnSortingState.ASC
                  ? ArrowDown
                  : ArrowUp
              }
              alt="Ascending"
            />
          ) : null}
        </div>
      </div>
    </th>
  );
};
export default listViewHeader;
